
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import KTAside from '@/layout/aside/Aside.vue';
import KTHeader from '@/views/new-design/layout/Header.vue';
import KTFooter from '@/views/new-design/layout/Footer.vue';
import HtmlClass from '@/core/services/LayoutService';
import KTScrollTop from '@/layout/extras/ScrollTop.vue';
import KTUserMenu from '@/layout/header/partials/UserMenu.vue';
import KTLoader from '@/components/Loader.vue';
import AlertChangePassword from '@/views/new-design/components/guide/ChangePassword.vue';

import { Actions } from '@/store/enums/StoreEnums';
import {
  Actions as AuthActions,
  Getters as AuthGetters,
  Mutations as AuthMutations,
} from '@/store/enums/AuthEnums';
import {
  // toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo,
} from '@/core/helpers/config';
import router from '@/router';
import store from '@/store';
import image from '@/utils/image';

export default defineComponent({
  name: 'Layout',
  components: {
    KTAside,
    KTHeader,
    KTFooter,
    KTScrollTop,
    //KTCreateApp,
    KTUserMenu,
    //KTDrawerMessenger,
    KTLoader,
    // KTMobilePageTitle,
    AlertChangePassword,
  },
  data: () => {
    return {};
  },
  computed: {
    ...mapGetters({
      authUser: AuthGetters.GET_AUTH_USER,
    }),

    currentUser() {
      return this.authUser;
    },

    username() {
      if (this.authUser?.first_name && this.authUser?.last_name) {
        return `${this.authUser.first_name} ${this.authUser.last_name}`;
      }

      return `${this.authUser.email}`;
    },

    setRouteIsDashboard() {
      return router.currentRoute.value.name === 'dashboard';
    },
    pageTitle() {
      return store.getters.pageTitle;
    },
    breadcrumbs() {
      return store.getters.pageBreadcrumbPath;
    },
    isDashboard() {
      return this.$router.currentRoute.value;
    },
  },

  mounted() {
    setTimeout(() => {
      // Remove page loader after some time
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading');
    }, 500);
  },

  methods: {
    ...mapActions({
      getAuthUser: AuthActions.FETCH_AUTH_USER,
      // getProfilePicture: AuthActions.PULL_USER_PROFILE_PICTURE,
    }),
    // getAvatarData() {
    //   store.commit(AuthMutations.SET_AUTH_USER_PROFILE_PICTURE, '');

    //   this.getProfilePicture().then((rawData) => {
    //     const imageData = image.rawImageToDataUrl(rawData, 'jpg');
    //     store.commit(AuthMutations.SET_AUTH_USER_PROFILE_PICTURE, imageData);
    //   });
    // },
  },

  setup() {
    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading');

    // initialize html element classes
    HtmlClass.init();

    return {
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      themeLightLogo,
      themeDarkLogo,
    };
  },
});
